import { useTranslation } from 'react-i18next';

import { Text, Title } from '../../typography';

type P = {
  subtitle: string;
  title: string;
};

/** @deprecated - use new Tabs instead */
const CardTabDeprecated = ({ subtitle, title }: P) => {
  const { t } = useTranslation();

  return (
    <>
      <Title level={5} marginBottom>
        {t(title)}
      </Title>
      <Text size="small">{t(subtitle)}</Text>
    </>
  );
};

export default CardTabDeprecated;
